// Deterministic initials-based avatar helpers (iter95).
// - No gender / demographic data collected or inferred.
// - Colour picked from a fixed palette using a name-hash so the SAME user
//   always gets the SAME colour across the app.
// - Consumers can render as a <div> (full control) or use <InitialsAvatar/>.

const PALETTE = [
  '#1800ad', // brand indigo
  '#ff8500', // brand orange
  '#00bf63', // brand green
  '#0ea5e9', // sky
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#14b8a6', // teal
  '#f59e0b', // amber
  '#ef4444', // red
  '#22c55e', // green
];

const hashString = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = ((h << 5) - h) + str.charCodeAt(i);
    h |= 0; // 32-bit int
  }
  return Math.abs(h);
};

export const getInitials = (name = '') => {
  const trimmed = String(name || '').trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

export const getAvatarColor = (nameOrId = '') => {
  const key = String(nameOrId || '?');
  return PALETTE[hashString(key) % PALETTE.length];
};

// Full user picture URL — handles absolute URLs, backend-relative paths,
// or falls back to null so the caller can render initials instead.
export const getUserPictureUrl = (user) => {
  if (!user?.picture) return null;
  const p = user.picture;
  if (p.startsWith('http') || p.startsWith('data:') || p.startsWith('blob:')) return p;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}${p}`;
};
